import { GetApplicationDataResponse } from 'handlers/applicationData';
import { WhatIsTheIssueResult } from 'enums/FlowNextResults';

import Api, { FetchMethodType } from './Api';

export interface SendDirectDepositEnrollmentFormEmailData {
  applicationId: string;
  hrEmail?: string;
  errorOptionSelected?: WhatIsTheIssueResult;
}

export interface EmailApi {
  sendOfferComparisonEmail(applicationId: string): Promise<void>;
  sendDirectDepositEnrollmentFormEmail(
    data: SendDirectDepositEnrollmentFormEmailData,
  ): Promise<GetApplicationDataResponse>;
  sendStudentLoanEnrollmentFormEmail(applicationId: string): Promise<void>;
}

export default class EmailRestApi extends Api implements EmailApi {
  public async sendOfferComparisonEmail(applicationId: string): Promise<void> {
    await this.fetch(`/loanOffer/sendOfferComparisonEmail/${applicationId}`, {
      method: FetchMethodType.POST,
    });
  }

  public async sendDirectDepositEnrollmentFormEmail(
    data: SendDirectDepositEnrollmentFormEmailData,
  ): Promise<GetApplicationDataResponse> {
    return (await this.fetch(`/payrollDeduction/directDeposit/enrollment/email/${data.applicationId}`, {
      method: FetchMethodType.POST,
      body: data,
    })) as GetApplicationDataResponse;
  }

  public async sendStudentLoanEnrollmentFormEmail(applicationId: string): Promise<void> {
    await this.fetch(`/studentLoan/application/${applicationId}/sendEnrollmentForm`, {
      method: FetchMethodType.POST,
    });
  }
}
